<template>
    <div class="mt-5">
	    <!-- Question -->
	    <div v-if="data.meta" class="d-flex flex-column gap-3 text-center mb-5">
		    <h3 v-if="questionDescription" class="fw-semi-bold m-0" v-html="questionDescription"></h3>
		    <p v-if="questionSubText" class="text-secondary m-0" v-html="questionSubText"></p>
	    </div>

        <!-- Input -->
        <div class="d-flex gap-4 justify-content-between align-items-center">
            <div class="flex-grow-1">
                <label for="year" class="form-label">Year</label>
                <select v-model="selectedYear" id="year" class="form-select py-2">
                    <option v-for="year in years" :key="year" :value="year">
                        {{ year }}
                    </option>
                </select>
            </div>

            <div class="flex-grow-1">
                <label for="month" class="form-label">Month</label>
                <select id="month" class="form-select py-2" v-model="selectedMonth">
                    <option v-for="(month, index) in months" :key="index" :value="index + 1">
                        {{ month }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';

const props = defineProps({
	questionDescription: String,
	questionSubText: String,
    data: Object,
	answer: {
		type: Array,
		default: () => []
	}
});

const selectedYear = ref(props.answer && props.answer.length ? new Date(props.answer[0].value).getFullYear() : new Date().getFullYear());
const currentYear = new Date().getFullYear();
const years = computed(() => {
    const yearsArray = [];
    for (let year = 1950; year <= currentYear; year++) {
        yearsArray.push(year);
    }
    return yearsArray;
});

const selectedMonth = ref(props.answer && props.answer.length ? new Date(props.answer[0].value).getMonth() + 1 : new Date().getMonth() + 1);
const months = ref([
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
]);


const date = ref(props.answer && props.answer.length ? new Date(props.answer[0].value) : null);

const setDate = () => {
	if (selectedYear.value && selectedMonth.value) {
		date.value = new Date(selectedYear.value, selectedMonth.value - 1, 1);
	} else {
		date.value = null;
	}
};

watch([selectedYear, selectedMonth], () => {
	setDate();
});

const emit = defineEmits(['question-answered']);
watch(date, (newVal, oldVal) => {
	if(newVal) {
		let answerToReturn = [{ value: newVal.getTime(), text: `${months.value[newVal.getMonth()]} ${newVal.getFullYear()}` }];
		emit('question-answered', answerToReturn);
	}
})

</script>